import { computed } from 'vue';
import { useStore } from 'vuex';
import { ModuleTourGuide } from '@/stores/moduleConst.js';

export const useTourGuide = () => {
  const store = useStore();

  /**
   * Tour Guide Config
   * @author: BMThang(03/04/2023)
   */
  const tourGuideConfig = computed(() => {
    return store.state[ModuleTourGuide].tourGuideConfig;
  })
  
  /**
   * Đã lấy đc dữ liệu chưa
   * @author: BMThang(03/04/2023)
   */
  const isGettedData = computed(() => {
    return store.state[ModuleTourGuide].isGettedData;
  })

  const tourLiveChat = computed(() => {
    return store.state[ModuleTourGuide].tourLiveChat;
  })

  /**
   * Mở tour guide
   * @param {number} steps Danh sách bước
   * @param {number} step Bước kích hoạt khi mở
   * @author: BMThang(31/03/2023)
   */
  const openTourGuide = (steps = [], step = 1) => {
    // Chưa lấy đc dữ liệu thì cook
    if (!isGettedData.value) return;
    store.commit(`${ModuleTourGuide}/openTourGuide`, {
      steps,
      step,
    });
  }
  
  return {
    tourGuideConfig,
    isGettedData,
    openTourGuide,
    tourLiveChat,
  }
}